module.exports = __webpack_public_path__ + "img/el-ic-idcard.152208e1.svg";